!(function () {
  "use strict";
  var e,
    t = {
      7257: function (e, t, n) {
        var o = n(4306),
          r = n(1711),
          i = n(2711),
          u = n.n(i);
        function c() {
          setTimeout(function () {
            var e = document.getElementById("header").offsetHeight;
            document.body.style.setProperty(
              "--header-height",
              "".concat(e, "px")
            );
            var t = document.getElementById("footer").offsetHeight;
            document.body.style.setProperty(
              "--footer-height",
              "".concat(t, "px")
            );
            var n = window.innerHeight;
            document.body.style.setProperty(
              "--window-height",
              "".concat(n, "px")
            );
            var o = document.getElementById("top-bar");
            if (o) {
              var r = o.offsetHeight;
              document.body.style.setProperty(
                "--topbar-height",
                "".concat(r, "px")
              );
            } else document.body.style.setProperty("--topbar-height", "0px");
          }, 100);
        }
        var a = n(5931);
        function s(e) {
          var t = [];
          return (
            e.items &&
              e.items.forEach(function (e) {
                var n = e.featured_image.url,
                  o = e.final_price / 100;
                t.push({
                  title: e.product_title,
                  key: e.key,
                  price: o,
                  id: e.variant_id,
                  options: e.options_with_values,
                  image: n,
                  qty: e.quantity,
                  remove: function () {
                    var e;
                    (e = this.key),
                      a.cl(e).then(function (e) {
                        f(e);
                      });
                  },
                  update: function (e) {
                    d(this.key, parseInt(e));
                  },
                  increase: function () {
                    d(this.key, parseInt(this.qty + 1));
                  },
                  decrease: function () {
                    d(this.key, parseInt(this.qty - 1));
                  },
                });
              }),
            { total: e.items_subtotal_price / 100, products: t }
          );
        }
        function d(e, t) {
          a.$G(e, { quantity: t }).then(function (e) {
            f(e);
          });
        }
        function f(e) {
          window.dispatchEvent(
            new CustomEvent("updateproducts", { detail: { cart: s(e) } })
          ),
            window.dispatchEvent(
              new CustomEvent("updatecartcount", {
                detail: { cartTotal: e.item_count },
              })
            );
        }
        function l() {
          document.body.offsetHeight < 2500 &&
            window.dispatchEvent(
              new CustomEvent("updatelong", { detail: { long: !1 } })
            );
        }
        a.y0().then(function (e) {
          f(e);
        }),
          c(),
          window.addEventListener("resize", c),
          (window.Alpine = o.Z),
          o.Z.start(),
          u().init({ duration: 900, once: !0 }),
          l(),
          window.addEventListener("resize", l);
        var h = document.getElementById("footer-subscribe");
        h &&
          h.addEventListener("submit", function (e) {
            e.preventDefault();
            var t = document.getElementById("footer-email").value;
            console.log(
              "🚀 ~ file: base.js ~ line 40 ~ footerSub.addEventListener ~ email",
              t
            ),
              (0, r.L)("RqZ5HT", t).then(function (e) {
                e.success
                  ? (document
                      .getElementById("footer-message")
                      .classList.remove("hidden"),
                    (document.getElementById("footer-email").value = ""))
                  : (document
                      .getElementById("footer-message")
                      .classList.remove("hidden"),
                    (document.getElementById("footer-message").innerHTML =
                      "There was an error."));
              });
          });
        var h1 = document.getElementById("landing-page-subscribe");
        h1 &&
          h1.addEventListener("submit", function (e) {
            e.preventDefault();
            var t = document.getElementById("landing-page-email").value;
            console.log(
              "🚀 ~ file: base.js ~ line 40 ~ footerSub.addEventListener ~ email",
              t
            ),
              (0, r.L)("RqZ5HT", t).then(function (e) {
                e.success
                  ? (document
                      .getElementById("landing-page-message")
                      .classList.remove("hidden"),
                    (document.getElementById("footer-email").value = ""))
                  : (document
                      .getElementById("landing-page-message")
                      .classList.remove("hidden"),
                    (document.getElementById("landing-page-message").innerHTML =
                      "There was an error."));
              });
          });
        var h2 = document.getElementById("landing-page-subscribe-2");
        h2 &&
          h2.addEventListener("submit", function (e) {
            e.preventDefault();
            var t = document.getElementById("landing-page-email-2").value;
            console.log(
              "🚀 ~ file: base.js ~ line 40 ~ footerSub.addEventListener ~ email",
              t
            ),
              (0, r.L)("RqZ5HT", t).then(function (e) {
                e.success
                  ? (document
                      .getElementById("landing-page-message-2")
                      .classList.remove("hidden"),
                    (document.getElementById("footer-email").value = ""))
                  : (document
                      .getElementById("landing-page-message-2")
                      .classList.remove("hidden"),
                    (document.getElementById("landing-page-message-2").innerHTML =
                      "There was an error."));
              });
          });
      },
      720: function () {},
    },
    n = {};
  function o(e) {
    var r = n[e];
    if (void 0 !== r) return r.exports;
    var i = (n[e] = { id: e, loaded: !1, exports: {} });
    return t[e].call(i.exports, i, i.exports, o), (i.loaded = !0), i.exports;
  }
  (o.m = t),
    (e = []),
    (o.O = function (t, n, r, i) {
      if (!n) {
        var u = 1 / 0;
        for (d = 0; d < e.length; d++) {
          (n = e[d][0]), (r = e[d][1]), (i = e[d][2]);
          for (var c = !0, a = 0; a < n.length; a++)
            (!1 & i || u >= i) &&
            Object.keys(o.O).every(function (e) {
              return o.O[e](n[a]);
            })
              ? n.splice(a--, 1)
              : ((c = !1), i < u && (u = i));
          if (c) {
            e.splice(d--, 1);
            var s = r();
            void 0 !== s && (t = s);
          }
        }
        return t;
      }
      i = i || 0;
      for (var d = e.length; d > 0 && e[d - 1][2] > i; d--) e[d] = e[d - 1];
      e[d] = [n, r, i];
    }),
    (o.n = function (e) {
      var t =
        e && e.__esModule
          ? function () {
              return e.default;
            }
          : function () {
              return e;
            };
      return o.d(t, { a: t }), t;
    }),
    (o.d = function (e, t) {
      for (var n in t)
        o.o(t, n) &&
          !o.o(e, n) &&
          Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
    }),
    (o.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    })()),
    (o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (o.nmd = function (e) {
      return (e.paths = []), e.children || (e.children = []), e;
    }),
    (o.j = 348),
    (function () {
      var e = { 348: 0 };
      o.O.j = function (t) {
        return 0 === e[t];
      };
      var t = function (t, n) {
          var r,
            i,
            u = n[0],
            c = n[1],
            a = n[2],
            s = 0;
          if (
            u.some(function (t) {
              return 0 !== e[t];
            })
          ) {
            for (r in c) o.o(c, r) && (o.m[r] = c[r]);
            if (a) var d = a(o);
          }
          for (t && t(n); s < u.length; s++)
            (i = u[s]), o.o(e, i) && e[i] && e[i][0](), (e[i] = 0);
          return o.O(d);
        },
        n = (self.webpackChunkworkflow = self.webpackChunkworkflow || []);
      n.forEach(t.bind(null, 0)), (n.push = t.bind(null, n.push.bind(n)));
    })(),
    o.O(void 0, [216], function () {
      return o(7257);
    });
  var r = o.O(void 0, [216], function () {
    return o(720);
  });
  r = o.O(r);
})();